import { Box, Card, CardContent, Link, Typography } from '@mui/material'

import { Link as RouterLink } from 'react-router-dom'

export const NotFoundPage = () => {
  return (
    <Box>
      <Card>
        <CardContent>
          <Typography variant="h1">404 — Page Not Found</Typography>
          <Link component={RouterLink} to="search">
            <Typography variant="h2">Return to Search</Typography>
          </Link>
        </CardContent>
      </Card>
    </Box>
  )
}
